<template>
    <div id="header" class="header fixed w-full z-50">
        <!--<header class="h-24 tablet:h-12 bg-theme-green flex items-center flex-wrap tablet:justify-between">-->
        <header class="headersp h-12 bg-theme-green flex items-center justify-center">
            <div class="headerlistsp flex w-1280 min-w-min justify-between ml-4">
                <div class="ma0 flex items-start flex-col">

                    <a href="/contents/lp/ichioshi/" class="router-link-active router-link-exact-active"
                        aria-current="page">
                        <img class="top-logo" :src="img_common_path + ichioshi_logo" alt="TOPのロゴ"></a>
                    <!-- <p class="text-txt-white text-xs laptop:text-sm flex items-center">イチオシ家具カタログに載せきれなかった商品を掲載しております。</p> -->
                    <!--<p class="text-txt-white text-sm laptop:text-xs desktop:text-sm flex items-center">{{search_word}}</p>-->
                </div>
                <div class="ma0 flex justify-between flex-wrap items-center">
                    <div class="search-box shrink">
                        <!-- <input style="outline:1px solid rgb(133, 133, 133);outline-offset: -1px;" class="text-sm w-60 p-1"
                            type="text" name="" placeholder="商品名や商品コードで検索" /> -->
                        <input class="searchbar text-sm w-60 p-1" type="text" name="" v-model="search_word"
                            placeholder="商品名や商品コードで検索" />
                        <router-link :to="{ name: 'Search', query: { operationtype: 'search', searchtxt: search_word } }"
                            class="text-sm px-4 w-12 text-white bg-btn-gray font-bold text-txt-white p-1">検索</router-link>
                        <!--<input class="text-sm w-28 tablet:w-10 tablet:text-xs laptop:text-xs desktop:w-24 text-white bg-btn-gray font-bold text-txt-white w-16 p-1" type="submit" name="" value="検索"/>-->
                    </div>
                    <div class="btn-list flex items-center">
                        <li class="list-none" style="margin-left: 10px;">
                            <a class="about_btn" href="https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/docs/about.pdf"
                                target="_blank">イチオシ家具について</a>
                        </li>
                        <li class="list-none" style="margin-left: 10px;">

                            <a class="about_btn" href="https://www.smartschool.jp/contents/userguide.php"
                                target="_blank">ご利用ガイド</a>
                        </li>
                        <!--<li class="list-none px-1"><router-link v-scroll-to="'#toDelivery'" class="text-txt-black text-xs laptop:text-sm ">▶︎ 納品について</router-link></li>-->
                    </div>
                </div>
            </div>
        </header>
    </div>
</template>

<script>
import { ref } from 'vue'
export default {
    methods: {
        handleClick: function () {
            window.scroll({ top: 0, behavior: 'smooth' });
        }
    },
    setup() {
        const img_common_path = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/img/common/"
        const ichioshi_logo = "ichioshi_logo.svg"
        const logo_ichioshi = "logo_ichioshi.png"

        const search_word = ref('')

        return {
            img_common_path,
            ichioshi_logo,
            logo_ichioshi,
            search_word
        }
    },

}
</script>